/* eslint-disable jsx-a11y/alt-text */
import { Button, Form, Input, message } from 'antd';
import { Formik } from 'formik';
import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import { AuthApi, GeneralApi, UserApi } from '../../apis';
import { useDispatch } from 'react-redux';
import { setAccessToken, setIsLogin } from '../../store/reducer/auth';
import { delay } from '../../utils';
import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { IGeneral } from '../../interfaces';

const validationSchema = yup.object({
  username: yup.string().min(3, 'Хэт богино байна').required('Нэвтэх нэр оруулна уу'),
  password: yup.string().required('Нууц үгээ оруулна уу'),
});

const LoginForm = memo(() => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { mutate } = useSWR('/api/user/me', UserApi.me);
  const { mutate: mutateInit } = useSWR<IGeneral>('/api/init', GeneralApi.init);
  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: { username?: string; password?: string }) => {
      setLoading(true);

      try {
        const res = await AuthApi.login(values as any);
        dispatch(setAccessToken(res));
        dispatch(setIsLogin(true));
        mutateInit();
        await delay(1000);
        const me = await UserApi.me();
        mutate(me, false);
      } catch (error: any) {
        messageApi.open({
          type: 'error',
          content: error?.message,
        });
        setLoading(false);
      }
    },
    [dispatch, messageApi, mutate, mutateInit]
  );

  return (
    <>
      {contextHolder}
      <Container>
        <Formik
          initialValues={{ username: undefined, password: undefined }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => {
            return (
              <Form>
                <div className="card">
                  <div className="inputContainer">
                    <img src={require('../../assets/main-logo.png')} className="logo" />
                    <div className="h100" />
                    <label className="title">Нэвтрэх нэр</label>
                    <div className="h8" />
                    <Input
                      name="username"
                      value={values.username}
                      onChange={handleChange}
                      placeholder="Нэвтрэх нэр"
                      status={touched.username && errors.username ? 'error' : ''}
                    />
                    <div className="h8" />
                    <Input.Password
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      placeholder="Нууц "
                      status={touched.username && errors.username ? 'error' : ''}
                    />
                    <div className="h-[14px]" />
                    <span
                      onClick={() => navigate(NavigationRoutes.Forgot_Screen)}
                      className="
                        flex flex-row justify-end w-full 
                        font-manrope font-medium text-[14px] leading-[160%] tracking-[-0.01em] 
                        text-right text-[#5869FF] 
                        cursor-pointer hover:underline
                      "
                    >
                      Нууц үгээ мартсан уу?
                    </span>
                    <div className="h-[14px]" />
                    <Button
                      loading={loading}
                      type="primary"
                      className="btn"
                      onClick={() => handleSubmit()}
                    >
                      Нэвтрэх
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Container>
    </>
  );
});

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  border: solid 1px black;
  justify-content: center;

  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .card {
    border: solid 1px #eceaea;
    height: 350px;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }
  .inputContainer {
    width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 180px;
  }
  .h100 {
    height: 30px;
  }
  .btn {
    width: 100%;
  }
`;

LoginForm.displayName = 'LoginForm';

export { LoginForm };
